import { render, staticRenderFns } from "./use-cases-image.vue?vue&type=template&id=2fb417e5&scoped=true&"
import script from "./use-cases-image.vue?vue&type=script&lang=js&"
export * from "./use-cases-image.vue?vue&type=script&lang=js&"
import style0 from "./use-cases-image.vue?vue&type=style&index=0&id=2fb417e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb417e5",
  null
  
)

export default component.exports